var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nb-multi-select',{attrs:{"options":_vm.items,"label":_vm.answerBlockData.label},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }